<template>
  <VDialogV3
    id="assemblies-registry-dialog"
    :entity="shipment"
    position="right"
    hide-footer
    :title="title"
    :loading="false"
  >
    <AssembliesRegistryExpanded
      class="fill"
      :shipment="shipment"
      :filter-class="filterClass"
      :show-action-bar="showActionBar"
    />
  </VDialogV3>
</template>


<!-- Прокси над реестром сборок -->

<script lang="ts">
import type BasePageFilter from '@/domains/BasePageFilter/BasePageFilter';
import type Shipment       from '@/domains/Shipments/Shipment';

import AssembliesRegistryExpanded from '@/domains/Assemblies/components/AssembliesRegistryExpanded/AssembliesRegistryExpanded.vue';

export default defineComponent({
  name: 'AssembliesRegistryExpandedDialog',

  components: { AssembliesRegistryExpanded },

  props: {
    /**
     * Заголовок диалога. Если не передан — дефолтный "Сборочные листы".
     */
    title: {
      type:    String,
      default: 'Сборочные листы',
    },

    /**
     * Отгрузка-приёмник. При передаче реестр работает в режиме наполнения —
     * выбор позиции сборки конвертируется в ShipmentPosition и пишется
     * в shipment.positions.
     */
    shipment: {
      type:    Object as PropType<Shipment>,
      default: null,
    },

    /** Класс страничного фильтра (localStorage). */
    filterClass: {
      type:    Function as unknown as () => typeof BasePageFilter,
      default: null,
    },

    showActionBar: {
      type:    Boolean,
      default: false,
    },
  },
});
</script>
